// Custom user bookmark flags
export enum BookmarkFlagsEnum {
  UserGeneratedTour = 'user_generated_tour',
  Animated = 'animated',
  Quiz = 'quiz'
}
